module.exports = __webpack_public_path__ + "static/media/who-is-charity.fbe2bdf2.png";